import { observer } from "mobx-react";
import React from "react";
import { Modal, Stack, Text } from "@mantine/core";
import { Cubby } from "../../stores/Cubby";
import { JsonView, allExpanded, darkStyles } from "react-json-view-lite";
import "react-json-view-lite/dist/index.css";
import {
  MODAL_WIDTH_FOR_DATA_INTENSIVE_MODALS,
  MODALS,
} from "../../helpers/constants";
import { TextWithInfo } from "../modals/textWithInfo";
import { cleanNullsAndSort, removeRawData } from "../../helpers/sort";
import { TextWithInfoAndIcon } from "../dataDisplay/textWithInfoAndIcon";
import { ARTICLES } from "../../docs/docsIndex";
import { IconCircleMinus } from "@tabler/icons-react";

const ClosedChannels = observer(({ cubby }: { cubby: Cubby }) => {
  return (
    <>
      <Modal
        size={MODAL_WIDTH_FOR_DATA_INTENSIVE_MODALS}
        opened={cubby.currentModal === MODALS.CLOSED_CHANNELS}
        onClose={() => cubby.setModal(null)}
        title={
          <TextWithInfoAndIcon
            text="Closed Channels"
            articleSlug={ARTICLES.CLOSED_CHANNELS.slug}
            icon={<IconCircleMinus size={24} />}
            cubby={cubby}
            textSize="lg"
          />
        }
      >
        <Stack>
          {/* Map over cubby.payOffchainEvents.data and display each event in JsonView */}
          {cubby.closedChannels.map((channel, index) => (
            <div key={index}>
              <JsonView
                data={removeRawData(cleanNullsAndSort(channel))}
                shouldExpandNode={allExpanded}
                style={darkStyles}
              />
            </div>
          ))}
        </Stack>
      </Modal>
    </>
  );
});

export default ClosedChannels;
